class UmsomHelpers {

	/*
	 * Compiles a JavaScript object into HTML
	 *
	 */
	compileHTML(template, data) {
		
		//Get template
		var tp = Handlebars.templates[template];

		//Return compiled HTML
		return tp(data);
	
	};
	
	/*
	 * Returns RSS feed as JavaScript object
	 *
	 */
	getRSSFeed(url, count, output) {
		
		//Set params if not passed in
		count = count || 10;
		output = output || 'json';
		
		//Return the result
		return $.ajax({
			url: 'http://ajax.googleapis.com/ajax/services/feed/load?v=1.0&output='+output+'&num='+count+'&callback=?&q=' + encodeURIComponent(url),
			dataType: 'jsonp'
		});
		
	};
	
	/*
	 * Convert XML to JSON
	 *
	 */
	xmlToJson(xml) {
	// Create the return object
	var obj = {};

	if (xml.nodeType == 1) //Element
		{
			if (xml.attributes.length > 0)
			{
				obj["@attributes"] = {};
				
				for (var j = 0; j < xml.attributes.length; j++)
				{
					var attribute = xml.attributes.item(j);
					obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
				}
			}
	}
		else if (xml.nodeType == 3) //text
		{
			obj = xml.nodeValue;
		}

	//Do children
	if (xml.hasChildNodes())
		{
			for(var i = 0; i < xml.childNodes.length; i++)
			{
				var item = xml.childNodes.item(i);
				var nodeName = item.nodeName;
				
				if (typeof(obj[nodeName]) == "undefined")
				{
					obj[nodeName] = this.xmlToJson(item);
				}
				else
				{
					if (typeof(obj[nodeName].push) == "undefined")
					{
						var old = obj[nodeName];
						obj[nodeName] = [];
						obj[nodeName].push(old);
					}
					
					obj[nodeName].push(this.xmlToJson(item));
				}
			}
		}
		
		//Return result
		return obj;
	};
	
	/*
	 * Execute code after a delay
	 *
	 */
	delay() {
		var timer = 0;
		
		return function(callback, ms) {
			clearTimeout(timer);
			timer = setTimeout(callback, ms);
		};
	}
	
	/*
	 * Find tallest element from a jQuery collection
	 *
	 */
	findTallestElement($collection) {
		var tallest = 0;
		
		$collection.each(function() {
			
			var height = $(this).outerHeight();
			
			if(height > tallest)
			{
				tallest = height;
			}
			
		});
		
		return tallest;
	};
	
	/*
	 * Equal height items
	 *
	 */
	flexBox($parent, target) {
		//Get children
		var $children = $parent.find(target);
		
		//Add attributes so we can reinit flexbox on resize
		$parent.attr('data-flexbox', '');
		$children.attr('data-flexbox-child', '');
		
		//Set min height
		$parent.imagesLoaded(function() {
			var tallest = this.findTallestElement($children);
			$children.css('height', tallest);
		});
	};
	
	/*
	 * Gets the specified paramter from the URL
	 *
	 */
	getUrlParameter(param) {
		var params = window.location.search.substring(1);
	var paramsArray = params.split('&');
		
	for(var i = 0; i < paramsArray.length; i++) {
		var paramsName = paramsArray[i].split('=');
		
		if(paramsName[0] == param)
		{
			return paramsName[1];
		}
	}
	};
	
	/*
	 * Redirect to a URL with passed in parameters (object)
	 *
	 */
	redirect(url, params) {
		//Replace any encoded ampersands
		var cleanUrl = url.replace(/&amp;/g, '&');

		//Are we appending this paramater?
		if(cleanUrl.indexOf('?') > -1)
		{
			cleanUrl += '&';
		}
		else
		{
			cleanUrl += '?';    
		}

		//Redirect to page
		document.location.href = cleanUrl + jQuery.param(params);
	};
	
	/*
	 * Gets the current URL of the page
	 *
	 */
	getCurrentUrl() {
		//Get URL
		var url = window.location.pathname;

		//Replace starting slash
		url = url.replace(/^\//, '');

		//Are we in T4 preview?
		if(url === 'terminalfour/SiteManager') {

			//Add query param to URL
			url += window.location.search;

			//Remove terminal4 part, as this is not in the nav urls
			url = url.replace('terminalfour/','');

			//Get index of lang parameter
			var langIndex = url.indexOf('&lang=');

			//Remove URL info that does not appear in nav urls (everything after lang param)
			if(langIndex > 0) {
				url = url.substring(0, langIndex + 8);
			}

			//DEBUG
			window.console.log('Running in T4 preview mode');
			window.console.log('Matching URL: ' + url);

		} else if(window.location.search) {

			//Add query param to URL
			url += window.location.search;

		}
		
		return url;
		
	};
};

export default new UmsomHelpers();


// WEBPACK FOOTER //
// ./AppBundle/Resources/assets/js/umsom/umsom.helpers.js